import { PageName, PageType } from './pageConfig/Types';

export const BASE_RETAIL_PATH = 'newron-retail';
export const OLD_BASE_RETAIL_PATH = 'retail-insights';
export const COLLECTION_PATH = '/collections';
export const NOTIFICATIONS_PREFERENCES = '/notifications-preferences';
export const BASE_SERVICE_PATH = 'retail-insights';
export const BASE_PREFERENCE_PATH = 'preference-filters';

export enum RETAIL_ALLOWED_PATH {
  CALLBACK = 'callback',
  RETAILER_OVERVIEW = 'overview',
  CATEGORY_LEADERBOARD = 'category-leaderboard',
  PERFORMANCE_ANALYSIS = 'performance-analysis',
  OPPORTUNITY_REVIEW = 'opportunity-review',
  PRODUCTS_OVERVIEW = 'products/overview',
  PRODUCTS = 'products',
  PRODUCTS_LEADERBOARD = 'products/leaderboard',
  TRADING_ASSISTANT = 'trading-assistant',
  LEADERBOARD_PRODUCTS_COMPARE = 'products/leaderboard/compare',
  EXPLORE = 'explore',
  EXPLORE_TRENDS = 'explore/trends',
}

export const getPageTypeAndNameByPathName = (pathname: string) => {
  const strippedPathname = pathname.slice(1); // remove leading '/'
  const pathChecks = [
    {
      key: RETAIL_ALLOWED_PATH.CATEGORY_LEADERBOARD,
      pageType: PageType.CATEGORY_LEADERBOARD,
      pageName: PageName.CATEGORY_LEADERBOARD,
    },
    {
      key: RETAIL_ALLOWED_PATH.OPPORTUNITY_REVIEW,
      pageType: PageType.OPPORTUNITY_REVIEW,
      pageName: PageName.OPPORTUNITY_REVIEW,
    },
    {
      key: RETAIL_ALLOWED_PATH.PERFORMANCE_ANALYSIS,
      pageType: PageType.PERFORMANCE_ANALYSIS,
      pageName: PageName.PERFORMANCE_ANALYSIS,
    },
    {
      key: RETAIL_ALLOWED_PATH.RETAILER_OVERVIEW,
      pageType: PageType.RETAILER_OVERVIEW,
      pageName: PageName.RETAILER_OVERVIEW,
    },
    {
      key: RETAIL_ALLOWED_PATH.PRODUCTS,
      pageType: PageType.RI_PRODUCT,
      pageName: PageName.RI_PRODUCT,
    },
    {
      key: RETAIL_ALLOWED_PATH.TRADING_ASSISTANT,
      pageType: PageType.TRADING_ASSISTANT,
      pageName: PageName.TRADING_ASSISTANT,
    },
  ];
  const matchedPath = pathChecks.find(({ key }) => strippedPathname.includes(`${BASE_RETAIL_PATH}/${key}`));
  return {
    pageType: matchedPath?.pageType ?? PageType.EXPLORE,
    pageName: matchedPath?.pageName ?? PageName.EXPLORE,
  };
};

export const isAllowedRetailPath = (retailPath: string) => {
  return retailPath.includes(BASE_RETAIL_PATH) || retailPath.includes(OLD_BASE_RETAIL_PATH);
};

export const isProductsPath = (pathname: string) => {
  return pathname.includes(RETAIL_ALLOWED_PATH.PRODUCTS);
};

export const isTradingAssistantPath = (pathname: string) => {
  return pathname.includes(RETAIL_ALLOWED_PATH.TRADING_ASSISTANT);
};

export const getBaseRetailPathDefinition = (): string => {
  return `/`;
};

export const getRetailPathDefinition = (retailPath: RETAIL_ALLOWED_PATH | string): string => {
  return `/${retailPath}`;
};

export const getRetailPathForHistory = (retailPath: RETAIL_ALLOWED_PATH): string => {
  return retailPath;
};

export const getWildcardRetailPath = (): string => {
  return '/:page/*';
};

export const getNewronLogoutPath = (): string => {
  return '/logout';
};
